import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "faq-modal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "faq-modal--title" }, " Troubleshooting ", -1)
const _hoisted_3 = { class: "faq-modal--list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]

import BottomModal from '@/components/BottomModal.vue'
import { useFaq } from '@/store/faq'
import { ref, watchEffect } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqModal',
  props: {
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean;
};





const faq = ref()
const expandedFaq = ref()

const { getFaq } = useFaq()

const fetchFaq = async () => {
  faq.value = await getFaq()
}

const expandFaq = (id: number) => {
  let newId: number | null = id
  if (expandedFaq.value == newId) {
    newId = null
  }

  expandedFaq.value = newId
}

watchEffect(() => {
  if (props.show) {
    fetchFaq()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomModal, {
    size: "sm",
    show: __props.show,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.value, (v) => {
            return (_openBlock(), _createElementBlock("li", {
              key: v.id,
              class: _normalizeClass(["faq-modal--list-item", { 'faq-modal--list-item_active': expandedFaq.value == v.id }])
            }, [
              _createElementVNode("b", {
                onClick: _withModifiers(($event: any) => (expandFaq(v.id)), ["prevent"])
              }, _toDisplayString(v.title), 9, _hoisted_4),
              (expandedFaq.value == v.id)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    innerHTML: v.description
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})